// Local Shopify BGN/EUR Currency Converter by Milen v1.0 (based on RIZN logic)
(function () {
    if (window.BgnEurConverterShopifyInitialized) return;
    window.BgnEurConverterShopifyInitialized = true;

    const EUR_RATE = 1.95583;

    const TEXT_NODES_TO_CHECK = ['span', 'b', 'p', 'strong', 'div', 'li', 'a', 'option', 'del', 'sup', 'sub'];
    const OTHER_NODES_TO_CHECK = ['div', 'dd', 'td', 'ul', 'span', 'p', 's', 'del', 'sup', 'sub'];

    const BGN_REGEX = /(\d{1,3}(?:[\s.,]?\d{3})*(?:[.,]\d{2})?)\s*лв\.?/gi;

    function formatEUR(value) {
        return value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function convertToEur(number) {
        return (number / EUR_RATE).toFixed(2);
    }

    function matchPrice(text) {
        if (text.includes('€)') || text.includes('EUR)')) return null;

        return text.replace(BGN_REGEX, (match, p1) => {
            const clean = p1.replace(/\s/g, '').replace(',', '.').replace(/(\d)\.(?=\d{3})/g, '$1');
            const bgn = parseFloat(clean);
            if (isNaN(bgn) || bgn === 0) return match;

            const eur = convertToEur(bgn);
            const formatted = formatEUR(eur);
            return `${match} (${formatted} €)`;
        });
    }

    function replacePrice(node) {
        const updated = matchPrice(node.textContent);
        if (updated && updated !== node.textContent) {
            node.textContent = updated;
        }
    }

    function getElements(tagNames) {
        return tagNames.flatMap(tag => Array.from(document.getElementsByTagName(tag)));
    }

    function replacePrices() {
        let count = 0;
        const textNodes = getElements(TEXT_NODES_TO_CHECK);

        for (const node of textNodes) {
            if (!node.childNodes || node.childNodes.length === 0) continue;

            for (const textNode of node.childNodes) {
                if (textNode.nodeType !== Node.TEXT_NODE) continue;
                const original = textNode.textContent;
                replacePrice(textNode);
                if (textNode.textContent !== original) count++;
            }
        }

        const otherNodes = getElements(OTHER_NODES_TO_CHECK);

        for (const node of otherNodes) {
            if (
                node.childNodes &&
                node.childNodes.length === 1 &&
                node.childNodes[0].nodeType === Node.TEXT_NODE
            ) {
                const original = node.childNodes[0].textContent;
                replacePrice(node.childNodes[0]);
                if (node.childNodes[0].textContent !== original) count++;
            }
        }

        return count;
    }

    function init() {
        setTimeout(() => {
            replacePrices();
        }, 100);

        if (window.MutationObserver) {
            const observer = new MutationObserver(() => {
                setTimeout(() => {
                    replacePrices();
                }, 200);
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });

            window.BgnEurConverterShopify = {
                refresh: replacePrices,
                disconnect: () => {
                    observer.disconnect();
                    window.BgnEurConverterShopifyInitialized = false;
                },
                version: 'Local RZ Clone',
            };
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();
